import useSettings from "./useSettings";
import { SettingsHeader, Section, Field, Loading } from "./_shared";

export default function AnalyticsSettingsAdmin() {
  const { settings, set, save, saving, saved } = useSettings();
  if (!settings) return <Loading />;

  return (
    <div data-testid="cms-settings-analytics">
      <SettingsHeader
        title="Analítica"
        description="Configuración de Google Analytics 4 y consentimiento."
        onSave={save}
        saving={saving}
        saved={saved}
      />

      <Section title="Google Analytics 4 (opcional)">
        <p className="text-xs text-gray-500 mb-3">
          Introduzca su <strong>Measurement ID</strong> (ej. <code>G-XXXXXXXXXX</code>). El script solo se cargará
          cuando el visitante acepte la categoría &quot;Analíticas&quot; en el banner de cookies. Déjelo vacío para
          desactivar el tracking por completo.
        </p>
        <Field
          label="Measurement ID"
          value={settings.ga4_measurement_id ?? ""}
          onChange={(v) => set("ga4_measurement_id", v)}
          testId="settings-ga4-id"
        />
      </Section>
    </div>
  );
}
